// app/features/dashboard/components/TabNavigationComponent.tsx
"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"

import { cn } from "@/lib/utils"

const tabs = [
  { name: "Overview", href: "/dashboard" },
  { name: "Inbound", href: "/dashboard/inbound" },
  { name: "Outbound", href: "/dashboard/outbound" },
  { name: "Inbound (Live)", href: "/dashboard/inbound-live" },
]

export function TabNavigationComponent() {
  const pathname = usePathname()

  return (
    <div className="border-b border-gray-200">
      <nav className="flex space-x-8">
        {tabs.map((tab) => {
          const isActive = pathname === tab.href
          return (
            <Link
              key={tab.name}
              href={tab.href}
              className={cn(
                "border-b-2 py-4 px-1 text-sm font-medium transition-colors",
                isActive
                  ? "border-[var(--color-primary)] text-[var(--color-primary)]"
                  : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
              )}
            >
              {tab.name}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}

